import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import React from "react";

// const responsiveIcon = {
//   fontSize: {
//     xs: "1.7rem",
//     sm: "2rem",
//   },
//   mr: 1,
// };
const User = [
  [
    "User",
    "/admin/user/list",
    <PeopleOutlineIcon
      sx={{ fontSize: "2rem", ml: "0.3rem" }}
    ></PeopleOutlineIcon>,
  ],
];

export default User;
